import { useEffect, useRef, useState } from 'react'

export function useHybridIsMobile(initialIsMobile: boolean) {
  const [isMobile, setIsMobile] = useState(initialIsMobile)
  const prevWidth = useRef<number | null>(null)

  useEffect(() => {
    if (typeof window === 'undefined') return // ⛔ Prevents SSR DOM access

    const handleResize = () => {
      const width = window.innerWidth
      const nextIsMobile = width <= 1024 // includes mobile and tablet

      if (nextIsMobile !== isMobile) setIsMobile(nextIsMobile)
      prevWidth.current = width
    }

    // Initialize
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [isMobile])

  return isMobile
}
